<div #search
     [class.open]="adaptiveOpen"
     class="search">
    <div class="input_search">
        <i (click)="adaptiveOpen = !adaptiveOpen"
           class="icon-search"></i>
        <input (focus)="hideSidebar()"
               [formControl]="value"
               autocomplete="off"
               class="form-control form-control-lg"
               name="search"
               placeholder="{{'SEARCH.PLACEHOLDER' | translate}}"
               type="text">
        <div (click)="adaptiveOpen = false"
             class="close_mobile">
            <i class="icon-plus"></i>
        </div>
        <div *ngIf="searchHints"
             [@fade]="'in'"
             class="popup">
            <div id="search_result">
                <ng-container *ngFor="let item of searchHintsArr">
                    <a (click)="redirect(item)">
                        <i class="icon-{{documentHelper.fileExpansion(item.type)}}"></i><span>{{ item.name }}</span>
                    </a>
                </ng-container>
                <ng-container *ngIf="searchHintsArr.length === 0 && !loading">
                    <h3 style="padding: 0 10px;line-height: 32px;margin: 0">{{ 'SEARCH.NO_RES' | translate }}</h3>
                </ng-container>
                <ng-container *ngIf="loading">
                    <a>
                        <div class="donut"></div>
                    </a>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="config">
        <button (click)="settings = !settings; searchHints = false; hideSidebar()"
                class="search_settings"
                ngbTooltip="{{ 'SEARCH.FILTER' | translate }}"
                placement="bottom auto"><i class="icon-filter"></i></button>
        <div #searchFilter
             *ngIf="settings"
             [@fade]="'in'"
             class="popup">
            <button (click)="settings = !settings;"
                    class="btn-close float-end">
            </button>
            <h2>{{ 'SEARCH.TITLE' | translate }}</h2>
            <form>
                <app-component-form (formData)="form($event);"
                                    [data]="formData"
                                    [requestData]="getFormData"></app-component-form>
            </form>
            <br>
            <button (click)="getResult()"
                    class="btn btn-primary"
                    style="float: right">
                <span>{{ 'BUTTON_TEXT.APPLY' | translate }}</span>
            </button>
        </div>
    </div>
</div>
